export const contactForm: string = '/contactForm';
export const backofficeContactForms: string = '/backoffice/contactforms';
